import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6fbccc89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-if" }
const _hoisted_2 = {
  key: 0,
  class: "ui-if__anim"
}
const _hoisted_3 = { class: "ui-if__elm-search" }
const _hoisted_4 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconSearch = _resolveComponent("IconSearch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.text !== _ctx.EMPTY)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "ui-if__elm",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args)))
    }, [
      (_ctx.isShowIcon)
        ? (_openBlock(), _createBlock(_component_IconSearch, {
            key: 0,
            class: "ui-if__elm-icon",
            color: "rgb(119, 121, 124)",
            width: "16",
            height: "16"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          ref: "searchInput",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
          type: "text",
          class: "ui-if__elm-search-input",
          placeholder: _ctx.label
        }, null, 40, _hoisted_4)
      ])
    ])
  ]))
}